// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2Wbbh","select":"Header_select__2T4bG","clinic":"Header_clinic__3Ufk9"};